import {
  INCIDENT_TYPE_META,
  SEVERITY_META,
  STATUS_META,
} from "@/lib/incidentTypes";

export function IncidentTypeBadge({ type }) {
  const meta = INCIDENT_TYPE_META[type] || INCIDENT_TYPE_META.other;
  const Icon = meta.icon;
  return (
    <span
      data-testid={`incident-type-badge-${type}`}
      className={`inline-flex items-center gap-1.5 rounded-full ${meta.bg} px-3 py-1 text-xs font-semibold uppercase tracking-wider ${meta.color}`}
    >
      <Icon size={14} weight="duotone" aria-hidden />
      {meta.label}
    </span>
  );
}

export function SeverityBadge({ severity }) {
  const meta = SEVERITY_META[severity] || SEVERITY_META.low;
  return (
    <span
      data-testid={`severity-badge-${severity}`}
      className={`inline-flex items-center rounded-full border ${meta.ring} ${meta.bg} px-3 py-1 text-xs font-bold uppercase tracking-wider ${meta.color}`}
    >
      {meta.label}
    </span>
  );
}

export function StatusBadge({ status }) {
  const meta = STATUS_META[status] || STATUS_META.submitted;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full ${meta.bg} px-3 py-1 text-xs font-semibold uppercase tracking-wider ${meta.color}`}
    >
      {meta.label}
    </span>
  );
}
